import { map } from "rxjs";
import { Page, ProfileType } from "../../model";
import editoService from "../EditoService";

export interface PreviewPageOps {
  clusters: string[];
  country: string;
  device: string;
  organization: string;
  os: string;
  regions: string[];
  subscriptionPlan: string;
  subscriptionStatus: string;
  userProfile: ProfileType;
}
const previewPage = (
  pageUUid: string,
  offset = 0,
  limit = 10,
  opts: Partial<PreviewPageOps>,
) => {
  return editoService
    .post<{ page: Page }>({
      path: `pages/${pageUUid}/preview`,
      params: { offset, limit },
      body: {
        authorization: opts,
      },
    })
    .pipe(map((e) => e.page));
};

export { previewPage };
export default previewPage;
